<template>
  <section class="container">
    <van-tabs animated color='#4794ED' v-model="active">
      <van-tab title="预约停车" name='1'>
        <!-- <van-dropdown-menu active-color='#419FD9'>
          <van-dropdown-item v-model="value1" :options="option1" />
        </van-dropdown-menu> -->
        <div class="btn_box">
          <div>
            <div v-if="type==1" class="my_car" @click="GoJump('Reserve-List')">
              <div class="my_car__hb">
                <div class="header header1">
                  <div class="header__unavailable">
                    <span class="header__unavailable__title" style="color:#3C84FE">凤台南路停车场</span>
                    <span class="header__unavailable__content">余位：2
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div v-if="type==4" class="my_car" @click="GoJump('1')">
              <div class="my_car__hb">
                <div class="header header1">
                  <div class="header__unavailable">
                    <span class="header__unavailable__title" style="color:#3C84FE">南京火车站南广场停车场</span>
                    <span class="header__unavailable__content">余位：0</span>
                  </div>

                </div>
              </div>
            </div>
            <div v-if="type==4" class="my_car" @click="GoJump('1')">
              <div class="my_car__hb">
                <div class="header header2">
                  <div class="header__unavailable">
                    <span class="header__unavailable__title" style="color:#60BBF3">南京火车站北广场停车场</span>
                    <span class="header__unavailable__content">余位：0</span>
                  </div>
                </div>
              </div>
            </div>
            <div v-if="type==2" class="my_car" @click="GoJump('2')">
              <div class="my_car__hb">
                <div class="header header1">
                  <div class="header__unavailable">
                    <span class="header__unavailable__title" style="color:#3C84FE">聚宝山公园停车场</span>
                    <span class="header__unavailable__content">余位：0</span>
                  </div>
                </div>
              </div>
            </div>
            <div v-if="type==3" class="my_car" @click="GoJump('2')">
              <div class="my_car__hb">
                <div class="header header1">
                  <div class="header__unavailable">
                    <span class="header__unavailable__title" style="color:#3C84FE">南京儿童医院停车场</span>
                    <span class="header__unavailable__content">余位：0</span>
                  </div>
                </div>
              </div>
            </div>
            <div v-if="type==1" class="my_car" @click="GoJump('2')">
              <div class="my_car__hb">
                <div class="header header2">
                  <div class="header__unavailable">
                    <span class="header__unavailable__title" style="color:#60BBF3">人民中学停车场</span>
                    <span class="header__unavailable__content">余位：0</span>
                  </div>
                </div>
              </div>
            </div>
            <div v-if="type==1" class="my_car" @click="GoJump('2')">
              <div class="my_car__hb">
                <div class="header header3">
                  <div class="header__unavailable">
                    <span class="header__unavailable__title" style="color:#FF912F">田家炳中学停车场</span>
                    <span class="header__unavailable__content">余位：0</span>
                  </div>
                </div>
              </div>
            </div>
            <div v-if="type==1" class="my_car" @click="GoJump('2')">
              <div class="my_car__hb">
                <div class="header header4">
                  <div class="header__unavailable">
                    <span class="header__unavailable__title" style="color:#0FC6CE">春江学校停车场</span>
                    <span class="header__unavailable__content">余位：0</span>
                  </div>
                </div>
              </div>
            </div>
            <div v-if="type==1" class="my_car" @click="GoJump('2')">
              <div class="my_car__hb">
                <div class="header header1">
                  <div class="header__unavailable">
                    <span class="header__unavailable__title" style="color:#3C84FE">龙港科技园停车场</span>
                    <span class="header__unavailable__content">余位：0</span>
                  </div>
                </div>
              </div>
            </div>
            <div v-if="type==1" class="my_car" @click="GoJump('2')">
              <div class="my_car__hb">
                <div class="header header2">
                  <div class="header__unavailable">
                    <span class="header__unavailable__title" style="color:#60BBF3">红枫科技园停车场</span>
                    <span class="header__unavailable__content">余位：0</span>
                  </div>
                </div>
              </div>
            </div>
            <div v-if="type==1" class="my_car" @click="GoJump('2')">
              <div class="my_car__hb">
                <div class="header header3">
                  <div class="header__unavailable">
                    <span class="header__unavailable__title" style="color:#FF912F">江边路6号停车场</span>
                    <span class="header__unavailable__content">余位：0</span>
                  </div>
                </div>
              </div>
            </div>
            <div v-if="type==1" class="my_car" @click="GoJump('2')">
              <div class="my_car__hb">
                <div class="header header4">
                  <div class="header__unavailable">
                    <span class="header__unavailable__title" style="color:#0FC6CE">江边路24号停车场</span>
                    <span class="header__unavailable__content">余位：0</span>
                  </div>
                </div>
              </div>
            </div>
            <div v-if="type==2" class="my_car" @click="GoJump('2')">
              <div class="my_car__hb">
                <div class="header header2">
                  <div class="header__unavailable">
                    <span class="header__unavailable__title" style="color:#3C84FE">幕燕滨江风貌区停车场</span>
                    <span class="header__unavailable__content">余位：0</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </van-tab>
      <van-tab title="预约订单" name='2'>
        <div class="noData_container" v-if="!list.length">
          <div class="result_content">
            <van-image width="45%" height="auto" fit="contain" :src="result_icon" class="result_icon">
              <template v-slot:loading>
                <van-loading type="spinner" size="100" />
              </template>
            </van-image>
            <div class="result_title">您还没有相关订单</div>
          </div>
        </div>
        <div v-else class="order" v-for="(item,index) in list " :key='index'>
          <van-cell title="预约订单" size="large">
            <svg-icon slot="icon" class="order__icon" icon-class="我的订单" />
          </van-cell>

          <van-cell border size="large">
            <span slot="title">
              <van-row>
                <van-col span="6">预约车场</van-col>
                <van-col span="18" class="order__info">{{item.parkName}} </van-col>
              </van-row>
            </span>
          </van-cell>
          <van-cell border size="large">
            <span slot="title">
              <van-row>
                <van-col span="6">预约车位</van-col>
                <van-col span="18" class="order__info"> {{item.other}}</van-col>
              </van-row>
            </span>
          </van-cell>
          <van-cell border size="large">
            <span slot="title">
              <van-row>
                <van-col span="6">车牌号码</van-col>
                <van-col span="18" class="order__info">{{item.cardNumber}}</van-col>
              </van-row>
            </span>
          </van-cell>
          <van-cell border size="large">
            <span slot="title">
              <van-row>
                <van-col span="6">预约时间</van-col>
                <van-col span="12" class="order__info"> {{(item.startTime).substring(0,10) }} </van-col>
                <van-col span="6" class="order__info" v-if="config.projectName != 'YNTC'">
                  <van-button size="small" type="info" style="padding:10px" @click="cancel(item)">
                    取消预约
                  </van-button>
                </van-col>
              </van-row>
            </span>
          </van-cell>

        </div>
      </van-tab>
    </van-tabs>

  </section>
</template>

<script>
import noData from '@/assets/payment-related/noData@2x.png'

import { DropdownMenu, DropdownItem, DatetimePicker, Divider, Field, Toast, Picker, Popup, Tab, Tabs, Row, Col, Icon, NoticeBar } from 'vant'
import { decrypt } from '@/api/user'
import { getRecord, cancelAppointment } from '@/api/park'
import { insertOrder } from '@/api/reserve'
import { getUrlParam } from '@/utils'
import { parseTime } from '@/utils'
import {
  getLocalStorage
} from "@/utils/auth";
import config from '@/config/index'
import { mapGetters } from 'vuex'
export default {
  name: 'Reserve-Parking',
  components: {
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
    [Field.name]: Field,
    [Row.name]: Row,
    [Col.name]: Col,
    [Icon.name]: Icon,
    [NoticeBar.name]: NoticeBar,
    [Divider.name]: Divider,
    [DatetimePicker.name]: DatetimePicker,
    [Toast.name]: Toast,
    [Popup.name]: Popup,
    [Tabs.name]: Tabs,
    [Tab.name]: Tab,
    [Picker.name]: Picker,  },
  data () {
    return {
      type: 0,
      config, //全局项目配置信息
      plateNumber: [],
      columns: [],
      list: [],
      park: null,
      time: null, result_icon: noData,
      active: 1,
      phone: null,
      showTimePicker: false,
      showPicker: false,
      minDate: new Date(),
      currentDate: new Date(),
      listQuery: {
        //过滤参数
        page: 1,
        limit: 9999999,
      },
      params: {
        pickerTime: 1,
        parkId: 0,
        outTradeNo: null,
        startDate: [
          parseTime(
            new Date(
              new Date(new Date().toLocaleDateString('zh')).getTime() - 30 * 24 * 60 * 60 * 1000
            )
          ),
          parseTime(new Date(
            new Date(new Date().toLocaleDateString('zh')).getTime() +
            24 * 60 * 60 * 1000 - 1
          ))
        ],
      },
    }
  },
  computed: {
    ...mapGetters(['wx_userInfo', 'wx_token', 'token', 'jntcImg', 'imgBtn', 'CJ_Phone'])
  },
  mounted () {
    this.type = this.$route.query.type
    let _this = this
    _this.handleRefresh()




  },
  methods: {
    cancel (val) {
      console.log(val)
      let params = {
        platformId: val.platformId,
        id: val.id,
        wxOpenid: val.wxOpenid,
        isParkingOrRoadside: 1
      }
      cancelAppointment(params).then(res => {
        this.handleRefresh()
        this.$toast.success('取消成功')
      }).catch(err => {
        this.$toast.fail('取消失败')

      })
    },
    GoJump (val) {
      if (val == 1) {
        this.$toast('预约已满')

      } else if (val == 2) {
        this.$toast('敬请期待')
      } else {
        this.$router.push({
          name: val,
        })
      }
    },
    handleRefresh () {
      let _this = this
      if (getUrlParam("phone")) {
        let params = {
          phone: getUrlParam("phone")
        }
        decrypt(params).then(res => {
          _this.$store.dispatch('SetPhone', res.body.phone)
          _this.phone = res.body.phone
          let listparams = {
            wxOpenid: _this.phone,
            startTime: _this.params.startDate[0],
            endTime: _this.params.startDate[1],
            startPage: _this.listQuery.page,
            pageSize: _this.listQuery.limit,
            parkId: 670,
            // outTradeNo: _this.params.outTradeNo,
            isInvoice: 0,
          }
          getRecord(listparams).then(ress => {
            this.list = ress.body.data
          })
        })
      } else {
        let listparams = {
          wxOpenid: _this.CJ_Phone,
          startTime: _this.params.startDate[0],
          endTime: _this.params.startDate[1],
          startPage: _this.listQuery.page,
          pageSize: _this.listQuery.limit,
          parkId: 670,
          // outTradeNo: _this.params.outTradeNo,
          isInvoice: 0,
        }
        getRecord(listparams).then(ress => {
          this.list = ress.body.data
        })
      }
    },
    chosenTime (res) {
      console.log(res)
      this.time = parseTime(new Date(res))
      this.showTimePicker = false
    },
    formatter (type, val) {
      if (type === 'month') {
        return `${val}月`;
      } else if (type === 'day') {
        return `${val}日`;
      }
      return val;
    },
    onConfirm (res) {
      this.park = res
      this.showPicker = false
    },
    change (val) {
      this.plateNumber = val
    },
    submit () {

      let _this = this;
      if (!_this.plateNumber.join('')) {
        _this.$toast('请输入车牌号！')
        return
      }
      let result = true;
      const xreg = /^[京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领A-Z]{1}[A-Z]{1}(([0-9]{5}[DABCEFGHJK]$)|([DABCEFGHJK][A-HJ-NP-Z0-9][0-9]{4}$))/;
      const creg = /^[京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领A-Z]{1}[A-Z]{1}[A-HJ-NP-Z0-9]{4}[A-HJ-NP-Z0-9挂学警港澳]{1}$/;
      if (_this.plateNumber.join('').length == 7) {
        result = creg.test(_this.plateNumber.join(''));
      } else if (_this.plateNumber.join('').length == 8) {
        result = xreg.test(_this.plateNumber.join(''));
      } else {
        result = false;
      }
      if (!result) {
        _this.$toast('请输入正确的车牌号！')
        return
      }
      if (!this.park) {
        _this.$toast('请选择停车场！')
        return
      } else if (!this.time) {
        _this.$toast('请选择预约时间！')
        return
      }
      let params = {
        parkid: this.park.parkId,
        platenumber: _this.plateNumber.join(''),
        starttime: parseTime(new Date(this.time)),
        endtime: parseTime(new Date(this.time).getTime() + 24 * 60 * 60 * 1000 - 1)
      }
      insertOrder(params).then(res => {
        if (res.status == 1001) {
          // this.$store.commit('transaction/SET_BILL_PARAMS', params)
          this.$router.push({
            name: 'Reserve-Result',
          })
          this.$toast.success('预约成功')

        } else {
          this.$toast(res.message)
        }
      }).catch(err => {
        this.$toast(err)
      })

    }
  },

}
</script>

<style lang="scss" scoped>
.container {
  background-color: rgba(250, 250, 248, 1);
  .my_car {
    &__hb {
      padding: 5px 2.85vw 5px;

      .header1 {
        background: url(../../assets/BlpCardbg1.png);
      }
      .header2 {
        background: url(../../assets/BlpCardbg2.png);
      }
      .header3 {
        background: url(../../assets/BlpCardbg3.png);
      }
      .header4 {
        background: url(../../assets/BlpCardbg4.png);
      }
      .header4 {
        background: url(../../assets/BlpCardbg5.png);
      }
      .header {
        background-size: contain;
        background-position: center;
        background-repeat: no-repeat;
        position: relative;
        width: 100%;
        min-height: 120px;

        &__untied-btn {
          height: 80%;
          width: 33%;
          display: flex;
          align-items: flex-end;
          justify-content: flex-end;
          /deep/ .van-button--plain {
            background-color: rgba(0, 0, 0, 0);
          }
        }

        &__unavailable {
          width: 100%;
          position: relative;
          &__title {
            line-height: 55px;
            display: block;
            color: #fff;
            text-align: left;
            font-size: 20px;
            margin-left: 75px;
            font-weight: 400;
          }

          &__content {
            line-height: 60px;
            margin-left: 35px;
            text-align: left;
            display: block;
            font-weight: 400;
            font-size: 16px;
            color: black;
          }
          &__btn {
            position: absolute;
            bottom: 10px;
            right: 10px;
            padding: 10px;
          }
        }
      }
    }
  }
  .noData_container {
    height: calc(100vh - 50px);

    .result_content {
      display: flex;
      justify-content: center;
      flex-direction: column;
      flex-wrap: nowrap;
      height: px2rem(275);
      text-align: center;

      .result_icon {
        width: px2rem(120);
        height: auto;
        margin: 0 auto 20px;
      }

      .result_title {
        height: px2rem(40);
        line-height: px2rem(40);
        font-size: px2rem(22);
      }
    }

    .button_box {
      padding: 0 10px 0;
    }
  }
  .order {
    background: #ffffff;
    margin-bottom: 10px;
    border-radius: 5px;
    box-shadow: #a5a5a5 3px 3px 5px;
    margin: 10px;

    &__icon {
      font-size: 20px;
      color: #4b62ec;
      line-height: 24px;
      margin-right: 8px;
      height: 24px;
    }

    &__id {
      color: #444444;
      font-size: 16px;
      padding: 12px 16px;
      border-bottom: 1px solid #f3f4f5;
      background: #fff;
    }
    // /deep/ .van-dropdown-item {
    //   top: 50px !important;
    // }
    /deep/ .van-cell__title {
      color: #444444;

      .order__info {
        font-size: 16px;
        // text-align: right;
      }

      .order__money {
        font-size: 18px;
        color: #49a6ff;
      }
    }
  }
}
</style>